<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import OcupationalMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalMedicineAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import Pagination from "@/components/standard/OcupationalMedicine/OcupationalPagination";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.4 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    Pagination,
  },
  data() {
    return {
      title:
        "3.1.4 Evaluaciones médicas ocupacionales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Realización de los exámenes médicos ocupacionales",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],

      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      itemData: null,
      form_submitting: false,

      file: null,
      listaII: null,
      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
        exam_status: 0,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,

      search: "",
      loading: true,

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso",
        },
        {
          id: 2,
          name: "Exámenes periódicos",
        },
        {
          id: 3,
          name: "Examen de retiro",
        },
        {
          id: 4,
          name: "Examen post incapacidad",
        },
        {
          id: 5,
          name: "Examen por cambio de ocupación",
        },
      ],
    };
  },
  computed: {
    sortedLista() {
      const compareByDateDesc = (a, b) => {
        if (!a && !b) return 0;
        if (!a) return 1;
        if (!b) return -1;
        return new Date(b) - new Date(a);
      };

      return [...this.lista]
        .map((dato) => ({
          ...dato,
          ocupational_medical: [...(dato.ocupational_medical || [])].sort(
            (x, y) => compareByDateDesc(x.exam_date, y.exam_date)
          ),
        }))
        .sort((a, b) => {
          const aDate = a.ocupational_medical[0]
            ? a.ocupational_medical[0].exam_date
            : null;
          const bDate = b.ocupational_medical[0]
            ? b.ocupational_medical[0].exam_date
            : null;
          return compareByDateDesc(aDate, bDate);
        });
    },
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(26)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/3.1.4/${this.ocupationalMedicine.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.company.nit}/3.1.4/${this.ocupationalMedicine.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.ocupationalMedicine.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      OcupationalMedicineAPI.getAllMedicineCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          let medicine = response.Ocupational_medical.data;
          this.lista = medicine;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    async save() {
      this.form_submitting = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        OcupationalMedicineAPI.save(this.ocupationalMedicine)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 26,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000);
                window.location.reload();
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteMedicine(id) {
      OcupationalMedicineAPI.deleteMedicine(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 26,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha sido eliminado con éxito!",
                  icon: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              }, 2000);
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 26)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 26,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

  },

  mounted() {
    this.getUsers();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar las evaluaciones médicas
                      ocupacionales de ingreso, periódicas, de egreso, post
                      incapacidad y por cambio de ocupación, dando cumplimiento
                      a lo establecido por la resolución 2346 de 2007. Se deberá
                      almacenar los conceptos de aptitud laboral que respalden
                      la realización de las evaluaciones, además la empresa
                      deberá contar con la documentación de la IPS que realice
                      las evaluaciones, como son: Licencia en SST y certificado
                      de habilitación. En el ítem 3.1.3, se definirán los tipos
                      de evaluaciones y la frecuencia de realización de las
                      mismas. Los conceptos de aptitud laboral deberán ser
                      analizados y en caso de presentarse alguna recomendación
                      médica, se debe comunicar por escrito al colaborador y
                      posteriormente hacer seguimiento al cumplimiento de estas
                      recomendaciones.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row pt-3 px-2">
                <div class="col-8 text-right m-b-0"></div>
                <div class="col-4 text-right m-b-0">
                  <button :disabled="!allowAccess()" type="button" class="btn btn-primary">
                    <router-link class="text-white" :to="{
                      path: `/forms/estandares/${this.companyID}/medicina-ocupacional-comunicacion`,
                    }">Comunicación al colaborador
                    </router-link>
                  </button>

                  <br />
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="ocupationalMedicine.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha examen" label-for="date_exam">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="date" id="date_exam"
                      v-model="ocupationalMedicine.exam_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group id="cycle" label-for="cycle" class="col-md-6 px-2" label="Ciclo de examen">
                    <select required :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="ocupationalMedicine.exam_cycles_id">
                      <b-form-select-option v-for="item in list" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" class="btn btn-primary"
                    :disabled="!getRole('Crear') || !allowAccess() || this.form_submitting === true">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar') || !allowAccess()" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading">
                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                            <thead>
                              <tr>
                                <th>Colaborador/Aprendiz</th>

                                <th class="text-center align-middle">
                                  Ciclo del examen
                                </th>
                                <th class="text-center align-middle">
                                  Fecha del examen
                                </th>
                                <th class="text-center align-middle">
                                  Documento
                                </th>

                                <th class="text-center align-middle">
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in sortedLista" :key="dato.id">
                                <td>
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.ocupational_medical.length > 0">
                                    <div v-if="dato.ocupational_medical[0]
                                      .exam_cycles_id === 1
                                    ">
                                      <h6>Examen de ingreso</h6>
                                    </div>
                                    <div v-else-if="dato.ocupational_medical[0]
                                      .exam_cycles_id === 2
                                    ">
                                      <h6>Exámenes periódicos</h6>
                                    </div>
                                    <div v-else-if="dato.ocupational_medical[0]
                                      .exam_cycles_id === 3
                                    ">
                                      <h6>Examen de retiro</h6>
                                    </div>
                                    <div v-else-if="dato.ocupational_medical[0]
                                      .exam_cycles_id === 4
                                    ">
                                      <h6>examen post incapacidad</h6>
                                    </div>
                                    <div v-else-if="dato.ocupational_medical[0]
                                      .exam_cycles_id === 5
                                    ">
                                      <h6>examen por cambio de ocupación</h6>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <h6>No tiene examen</h6>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  {{
                                    dato.ocupational_medical.length > 0
                                      ? dato.ocupational_medical[0].exam_date
                                      : "Sin registro"
                                  }}
                                </td>

                                <td class="text-center align-middle">
                                  <div v-if="dato.ocupational_medical.length === 0">
                                    <h6>No hay archivo disponible</h6>
                                  </div>
                                  <div v-else>
                                    <button :disabled="!allowAccess()" style="
                                       background-color: transparent !important;
                                        border: none;
                                      " type="button" @click="
                                        gotoDigitalOcean(
                                          `${dato.ocupational_medical[0].file}`
                                        )
                                        ">
                                      <i class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>

                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <div v-if="dato.ocupational_medical.length > 0">
                                      <b-dropdown :disabled="!allowAccess()" variant="primary">
                                        <template v-slot:button-content>
                                          <i class="mdi mdi-eye"></i>
                                        </template>

                                        <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                          " :to="{
                                            path: `/forms/estandares/${dato.companies_id}/medicina-ocupacional-editar/${dato.ocupational_medical[0].id}`,
                                          }">Editar</b-dropdown-item>
                                        <b-dropdown-item :disabled="!getRole('Eliminar') ||
                                          !allowAccess()
                                          " v-on:click="
                                            deleteMedicine(
                                              dato.ocupational_medical[0].id
                                            )
                                            ">Eliminar</b-dropdown-item>
                                        <b-dropdown-item :disabled="!getRole('Consultar') ||
                                          !allowAccess()
                                          " :to="{
                                            path: `/forms/estandares/medicina-ocupacional-empleados/${dato.id}`,
                                          }">Ver registros</b-dropdown-item>
                                        <b-dropdown-item :disabled="!getRole('Consultar') ||
                                          !allowAccess()
                                          " :to="{
                                            path: `/forms/estandares/${dato.id}/medicina-ocupacional-danger/${dato.ocupational_medical[0].id}`,
                                          }">Recomendaciones</b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                    <div v-else></div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
